import { QuizConfig } from '../../types/quiz';

const dementiaRiskQuiz: QuizConfig = {
  id: 'dementia-risk',
  title: '치매 위험도 테스트',
  shortTitle: '치매 위험도',
  description: '12가지 질문으로 나의 치매 위험도를 확인해보세요',
  icon: '🧠',
  gradient: ['#E8EAF6', '#7986CB'],
  headerColor: '#C5CAE9',
  questions: [
    { id: 1, description: '최근 물건을 둔 곳을 자주 잊어버립니까?', yesScore: -3, noScore: 3 },
    { id: 2, description: '일주일에 3회 이상 유산소 운동을 합니까?', yesScore: 4, noScore: -2 },
    { id: 3, description: '가족(부모, 조부모) 중 치매 환자가 있습니까?', yesScore: -4, noScore: 3 },
    { id: 4, description: '독서, 퍼즐, 새로운 학습 등 인지 활동을 주 3회 이상 합니까?', yesScore: 4, noScore: -2 },
    { id: 5, description: '하루 7-8시간 규칙적으로 수면합니까?', yesScore: 3, noScore: -3 },
    { id: 6, description: '일주일에 3회 이상 음주합니까?', yesScore: -3, noScore: 3 },
    { id: 7, description: '우울하거나 무기력한 기분이 2주 이상 지속된 적이 있습니까?', yesScore: -3, noScore: 3 },
    { id: 8, description: '머리에 심한 충격(외상)을 받은 적이 있습니까?', yesScore: -3, noScore: 2 },
    { id: 9, description: '사회적 모임이나 대인관계를 주 1회 이상 유지합니까?', yesScore: 3, noScore: -3 },
    { id: 10, description: '고혈압, 당뇨, 고지혈증 중 하나 이상 진단받은 적이 있습니까?', yesScore: -3, noScore: 3 },
    { id: 11, description: '생선, 견과류 등 오메가-3가 풍부한 음식을 자주 먹습니까?', yesScore: 3, noScore: -2 },
    { id: 12, description: '최근 같은 이야기를 반복하거나, 약속을 잊는 일이 늘었습니까?', yesScore: -4, noScore: 3 },
  ],
  explanations: [
    { good: '기억력이 잘 유지되고 있어요! 두뇌 건강의 좋은 신호입니다.', bad: '가벼운 건망증도 반복되면 주의가 필요합니다. 메모 습관을 들여보세요.' },
    { good: '유산소 운동은 뇌 혈류를 개선하고 치매 위험을 40%까지 낮춥니다!', bad: '운동 부족은 뇌 위축을 촉진할 수 있습니다.' },
    { good: '가족력이 없다면 유전적 위험이 상대적으로 낮습니다.', bad: '가족력이 있으면 조기 검진과 예방 관리가 특히 중요합니다.' },
    { good: '인지 활동은 뇌의 인지 예비능을 높여 치매를 지연시킵니다!', bad: '뇌도 근육처럼 사용하지 않으면 기능이 저하됩니다.' },
    { good: '규칙적인 수면은 뇌의 노폐물(아밀로이드) 제거에 필수적입니다!', bad: '수면 부족은 알츠하이머 관련 단백질 축적을 촉진합니다.' },
    { good: '절제된 음주 습관이 뇌 건강을 보호합니다!', bad: '과도한 음주는 뇌세포를 직접적으로 손상시킵니다.' },
    { good: '정서적 안정은 뇌 건강 유지에 매우 중요합니다!', bad: '우울증은 치매 위험을 2배 이상 높일 수 있습니다.' },
    { good: '두부 외상이 없다면 그만큼 뇌 손상 위험이 낮습니다.', bad: '두부 외상은 만성 외상성 뇌병증(CTE) 위험을 높입니다.' },
    { good: '사회적 교류는 인지 기능 유지에 매우 효과적입니다!', bad: '사회적 고립은 치매 위험을 50% 이상 높일 수 있습니다.' },
    { good: '만성질환이 없다면 혈관성 치매 위험이 낮습니다!', bad: '혈관 질환은 혈관성 치매의 직접적인 원인이 됩니다.' },
    { good: '오메가-3는 뇌 신경세포 보호에 효과적입니다!', bad: '불균형한 식단은 뇌 염증을 촉진할 수 있습니다.' },
    { good: '인지 기능이 잘 유지되고 있어요!', bad: '반복적인 기억 문제는 경도인지장애(MCI)의 신호일 수 있습니다. 전문의 상담을 권합니다.' },
  ],
  healthTips: [
    { question: '기억력', tip: '매일 일기를 쓰거나 하루를 회상하는 습관이 기억력 유지에 도움됩니다.', icon: '📝' },
    { question: '운동', tip: '빠르게 걷기, 수영, 자전거 등 유산소 운동을 주 150분 이상 하세요.', icon: '🏃' },
    { question: '가족력', tip: '40대부터 정기적인 인지기능 검사를 받으시는 것을 권합니다.', icon: '🏥' },
    { question: '인지활동', tip: '새로운 언어 배우기, 악기 연주, 퍼즐 등으로 뇌를 자극하세요.', icon: '🧩' },
    { question: '수면', tip: '수면 무호흡증이 있다면 치료하세요. 깊은 수면이 뇌 청소에 필수적입니다.', icon: '😴' },
    { question: '음주', tip: '음주량을 주 2회 이하, 1회 2잔 이하로 줄이세요.', icon: '🍷' },
    { question: '우울', tip: '우울 증상이 지속되면 전문의 상담을 받으세요. 조기 치료가 치매 예방에 중요합니다.', icon: '💚' },
    { question: '두부외상', tip: '자전거, 스키 등 활동 시 반드시 헬멧을 착용하세요.', icon: '⛑️' },
    { question: '사회활동', tip: '동호회, 봉사활동, 친구 모임 등 사회적 교류를 꾸준히 유지하세요.', icon: '👥' },
    { question: '만성질환', tip: '혈압, 혈당, 콜레스테롤을 정기적으로 체크하고 관리하세요.', icon: '💊' },
    { question: '식습관', tip: '지중해식 식단(생선, 올리브유, 채소, 견과류)이 뇌 건강에 좋습니다.', icon: '🐟' },
    { question: '인지기능', tip: '기억력 저하가 지속되면 가까운 치매안심센터(1899-9988)에 문의하세요.', icon: '📞' },
  ],
  categories: [
    { name: '기억력/인지', color: '#5C6BC0', indices: [0, 11] },
    { name: '생활습관', color: '#4CAF50', indices: [1, 4, 5] },
    { name: '유전/가족력', color: '#9C27B0', indices: [2] },
    { name: '정신건강', color: '#FF9800', indices: [6, 8] },
    { name: '신체건강', color: '#f44336', indices: [7, 9] },
    { name: '영양/식습관', color: '#00BCD4', indices: [3, 10] },
  ],
  resultTiers: [
    { maxScore: -10, title: '뇌 비상사태', emoji: '🚨' },
    { maxScore: -2, title: '뇌에게 미안해지는 중', emoji: '😅' },
    { maxScore: 8, title: '평범한 뇌 소유자', emoji: '🧠' },
    { maxScore: 18, title: '뇌가 감사하는 중', emoji: '🤗' },
    { maxScore: Infinity, title: '아인슈타인급 뇌관리', emoji: '🏆' },
  ],
  baseValue: 50,
  resultUnit: '점',
  resultPrefix: '치매 위험도 ',
  resultSuffix: '',
  percentile: { mean: 8, sd: 12 },
  seo: {
    title: '치매 위험도 테스트 - 나의 치매 위험은?',
    description: '12가지 과학적 질문으로 치매 위험도를 자가진단해보세요. 기억력, 생활습관, 가족력을 종합 평가합니다.',
  },
};

export default dementiaRiskQuiz;
